import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from 'antd';

import Banner from './ParallaxBanner';
import LightBtn from './LightBtn';
import IntroText from './IntroText';
import AppStoreBtn from './AppStoreBtn';
import FadeInUp from '../../shared/Animation/FadeInUp';
import i18n from '../../../config/i18n';
import RequestDemo from './RequestDemo';

const StyledContent = styled.div`
  position: absolute !important;
  top: 30px !important;
  width: 100%;
  margin: 0 auto;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
`;

const HeroBanner = ({
  onRequestDemo,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleSubmit = (userData) => {
    setModalVisible(false);
    onRequestDemo(userData);
  };

  return (
    <div>
      <Banner />
      <StyledContent>
        <FadeInUp>
          <IntroText>
            {i18n.t('slogan')}
          </IntroText>
          <div>
            <LightBtn url={'/subscription'}>
              {i18n.t('tryForFree')}
            </LightBtn>
            <LightBtn onClick={() => setModalVisible(true)}>
              {i18n.t(['requestDemo', 'landingButtonText'])}
            </LightBtn>
            <Modal
              footer={null}
              onCancel={() => setModalVisible(false)}
              visible={modalVisible}
            >
              <RequestDemo
                onSubmit={handleSubmit}
              />
            </Modal>
          </div>
          <AppStoreBtn />
        </FadeInUp>
      </StyledContent>
    </div>
  );
};

HeroBanner.propTypes = {
  onRequestDemo: PropTypes.func.isRequired,
};
HeroBanner.defaultProps = {};


export default HeroBanner;



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/index.js